/**
 * Wiring to `src/core/`.
 *
 * This is the only file in `src/forms/` that reaches outside the module, and it is deliberately
 * trivial so that the sibling contract is visible in one place. Everything else in the engine
 * takes these as arguments.
 *
 * Relative imports rather than the `@/` alias the brief used, because no `@` alias is configured
 * in `vite.config.ts` today. If one is added later, this file is the only one to change.
 */

import { enqueue } from '../core/outbox.ts';
import { putBlob } from '../core/blobs.ts';
import { submitForm, storePhoto } from './submit.ts';
import type { BuildOptions, SubmissionPayload } from './payload.ts';
import type { SubmitResult } from './submit.ts';
import type { FormSchema, FormState, PhotoRef } from './types.ts';

/** Queues a completed form. Works fully offline: the outbox is the only path out. */
export function submitToOutbox(
  schema: FormSchema,
  state: FormState,
  options: BuildOptions,
): Promise<SubmitResult> {
  return submitForm(schema, state, { enqueue }, options);
}

/** Hands captured bytes to the blob store and returns the reference a photo field holds. */
export function capturePhoto(blob: Blob, at: number, label?: string): Promise<PhotoRef> {
  return storePhoto(blob, { putBlob }, at, label);
}

export type { SubmissionPayload };
